import React from "react";
import styled from "styled-components";
import bg from "../../images/add-to-home-screen-bg.png";
import IronLogoIcon from "../Icons/IronLogo";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";
import { CloseIcon, ShareIcon, ArrowIcon, AddButtonIcon } from "./Icons";
import { getIOSSemver } from "../common/iosVersion";
import { gaReducer } from "../GA";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 16000001;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
`;

const Container = styled.div`
  position: absolute;
  top: 9px;
  left: 9px;
  right: 9px;
  bottom: 18px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
`;

const TopBlock = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-image: url(${bg}),
    linear-gradient(to bottom, #47c0c8 0%, #5d67c0 100%);
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px 8px 0 0;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: 70px;
  background-color: #ffffff;
  border-radius: 8px;
`;

const Title = styled.h3`
  font-size: 28px;
  font-weight: 700;
`;

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

const BottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 121px;
  border-radius: 0 0 8px 8px;
`;

const Description = styled.p`
  margin-top: 23px;
  margin-bottom: 29px;
  font-size: ${fontSize(12)};
  color: #222222;
`;

const IconsBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Triangle = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  display: block;
  width: 26px;
  height: 13px;
  margin-left: -13px;
  border-top: 13px solid #ffffff;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
`;

const ShareIconContainer = styled.div`
  margin-left: 17px;
  margin-right: 22px;
`;

const ArrowIconContainer = styled.div`
  margin-right: 22px;
`;

const AddButtonIconContainer = styled.div``;

const CloseButton = styled.button`
  position: absolute;
  z-index: 10;
  top: 20px;
  right: 18px;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #ffffff;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

const A2HS_LS_KEY = "a2hs_ios_ppp";

class AddToHomeScreen extends React.Component {
  state = {
    show: false
  };

  checkState = () => {
    const ios = getIOSSemver();
    const properIos =
      ios && (ios.major > 11 || (ios.major === 11 && ios.minor >= 3));
    const portrait = window.innerWidth < window.innerHeight;
    const restrictedPage = /fillup|withdraw|sightseeing|verification/g.test(window.location.pathname);
    const webapp =
      "standalone" in window.navigator && window.navigator.standalone;
    const safari = /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent.toLowerCase());
    const iron = process.env.REACT_APP_DEPLOY_TARGET === "irontrade";

    if (!portrait || !properIos || restrictedPage || webapp || !safari || !iron) {
      return this.setState({ show: false });
    }

    if (window.setupWebapp) {
      return this.setState({ show: true });
    }

    if (this.props.sessionCount !== null) {
      try {
        let showCount = 1;
        let closeCount = 0;
        let sessionCount = this.props.sessionCount;
        const ls = localStorage.getItem(A2HS_LS_KEY);
        if (ls) {
          let [show, close, session] = ls.split(",");
          showCount = parseInt(show, 10);
          closeCount = parseInt(close, 10);
          sessionCount = parseInt(session, 10);

          if (
            this.props.sessionCount === sessionCount &&
            showCount <= closeCount
          ) {
            return null;
          }
        }

        if (this.props.sessionCount !== sessionCount) {
          sessionCount = this.props.sessionCount;
          showCount += 1;
        }

        if (showCount > 2 || closeCount > 2) {
          return null;
        }

        localStorage.setItem(
          A2HS_LS_KEY,
          `${showCount},${closeCount},${sessionCount}`
        );
      } catch (error) {}

      this.setState({ show: true });

      gaReducer("IOS_WEBAPP_POPUP_SHOW");
    }
  };

  componentDidMount() {
    this.checkState();
    window.addEventListener("resize", this.checkState);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkState);
  }

  closePopup = () => {
    window.setupWebapp = undefined;

    if (this.props.sessionCount !== null) {
      try {
        const ls = localStorage.getItem(A2HS_LS_KEY);
        if (ls) {
          const [show, close, session] = ls.split(",");
          localStorage.setItem(
            A2HS_LS_KEY,
            `${show},${parseInt(close, 10) + 1},${session}`
          );
        }
      } catch (error) {}
    }

    this.setState({ show: false });
  };

  render() {
    if (!this.state.show) {
      return null;
    }

    return (
      <Wrapper>
        <Overlay />
        <Container>
          <CloseButton onClick={this.closePopup}>
            <CloseIcon />
          </CloseButton>
          <TopBlock>
            <IconContainer>
              <IronLogoIcon />
            </IconContainer>
            <Title>
              {process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && <Gettext>Install IronTrade</Gettext>}
            </Title>
            <Subtitle>
              <Gettext>to your device</Gettext>
            </Subtitle>
          </TopBlock>
          <BottomBlock>
            <Description>
              <Gettext>Tap Share and then Add to homescreen</Gettext>
            </Description>
            <IconsBlock>
              <ShareIconContainer>
                <ShareIcon />
              </ShareIconContainer>
              <ArrowIconContainer>
                <ArrowIcon />
              </ArrowIconContainer>
              <AddButtonIconContainer>
                <AddButtonIcon />
              </AddButtonIconContainer>
            </IconsBlock>
          </BottomBlock>
          <Triangle />
        </Container>
      </Wrapper>
    );
  }
}

export default AddToHomeScreen;



// WEBPACK FOOTER //
// ./src/components/AddToHomescreenPopup/index.js